// removed by extract-text-webpack-plugin
module.exports = {"guest-event-container":"guest-event__guest-event-container__DFNy4","guest-event-container-draft":"guest-event__guest-event-container-draft__wo4KH","information":"guest-event__information__CTgc6","guest-flier-container":"guest-event__guest-flier-container__2GPso","draft-notice":"guest-event__draft-notice__3YlL5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/guest-event.scss
// module id = 1469
// module chunks = 1